import type { Branding, BrandingPatch } from '@cyberscore/contracts';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../../lib/api';
import { useSession } from '../../lib/session';

/** The organisation's colours (task 97). Saving one fetches the session again, so the app repaints in it. */

const key = (t: string | undefined) => ['branding', t] as const;

export function useBranding() {
  const { tenant } = useSession();
  return useQuery({
    queryKey: key(tenant?.id),
    queryFn: () => api<Branding>('GET', '/tenants/current/branding'),
    enabled: !!tenant,
  });
}

export function useSetBranding() {
  const qc = useQueryClient();
  const { tenant, reload } = useSession();
  return useMutation({
    mutationFn: (body: BrandingPatch) => api<Branding>('PATCH', '/tenants/current/branding', body),
    onSuccess: async (b) => {
      qc.setQueryData(key(tenant?.id), b);
      await reload();
    },
  });
}
